export const CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_RQUEST =
  "CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_RQUEST";
export const CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_SUCCESS =
  "CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_SUCCESS";
export const CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_FAILURE =
  "CREATE_FACEBOOK_MESSENGER_AUTO_SIGN_IN_FAILURE";
